import { Component, inject, Inject, Optional } from '@angular/core';
import { NavigationConfig, ProductListViewV2Component } from 'gung-standard';
import { CarLinerBrochuresHelperService } from '../../services/car-liner-brochures-helper.service';

@Component({
    selector: 'car-liner-brochures-product-list-view',
    templateUrl: './car-liner-brochures-product-list-view.component.html',
    styleUrls: ['./car-liner-brochures-product-list-view.component.scss'],
    standalone: false
})
export class CarLinerBrochuresProductListViewComponent extends ProductListViewV2Component {
  private carLinerBrochuresHelperService = inject(CarLinerBrochuresHelperService);

  productPartialId: string;
  disabled: string[] = [];
  maxQty: number;

  constructor(
    @Optional()
    @Inject('environment')
    public environment: NavigationConfig
  ) {
    super(environment);
    this.carLinerBrochuresHelperService.getProductId().subscribe(id => {
      this.productPartialId = id;
      this.maxQty = this.carLinerBrochuresHelperService.getMaxQty(id);
    });

    this.carLinerBrochuresHelperService.getBlockAddProduct().subscribe(blocked => {
      this.disabled = blocked;
    });
  }
}
